<template>
  <div v-if="showBanner" class="cookie-message">
    <div class="container">
      <div class="text">
        <p>
          We use first and third party cookies to improve your experience on our
          website. By browsing this website, you agree to our use of cookies.
        </p>
      </div>
      <div class="button-group">
        <Button theme="outline" @click="declineCookies">Reject</Button>
        <Button @click="acceptCookies">Accept and continue</Button>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";

export default {
  name: "CookieMessage",
  components: {
    Button,
  },
  data() {
    return {
      showBanner: false,
    };
  },
  mounted() {
    window.Shopify.loadFeatures(
      [
        {
          name: "consent-tracking-api",
          version: "0.1",
        },
      ],
      (error) => {
        if (error) {
          throw error;
        }

        this.initCookieBanner();
      }
    );
  },
  methods: {
    initCookieBanner() {
      const userCanBeTracked =
        window.Shopify.customerPrivacy.userCanBeTracked();
      const userTrackingConsent =
        window.Shopify.customerPrivacy.getTrackingConsent();

      if (!userCanBeTracked && userTrackingConsent === "no_interaction") {
        this.showBanner = true;
      }
    },
    declineCookies() {
      window.Shopify.customerPrivacy.setTrackingConsent(false, () => {
        this.showBanner = false;
      });
    },
    acceptCookies() {
      window.Shopify.customerPrivacy.setTrackingConsent(true, () => {
        this.showBanner = false;
      });

      document.addEventListener("trackingConsentAccepted", function () {
        console.log("trackingConsentAccepted event fired");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.cookie-message {
  background-color: $color-white;
  padding: 20px;
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 999;
  box-shadow: 0 10px 10px 10px rgba(black, 0.2);

  .container {
    @include respond-above(md) {
      display: flex;
      gap: 20px;
      justify-content: center;
      align-items: center;
    }
  }

  .text {
    margin-bottom: 20px;
    @include t__editorial-body-10;

    @include respond-above(md) {
      margin-bottom: 0;
    }
  }

  .button-group {
    display: flex;

    @include respond-above(md) {
      flex: 0 0 auto;
      display: block;
    }

    .button {
      flex: 1 1 auto;
    }

    .button + .button {
      margin-left: 10px;
    }
  }
}
</style>
